// autoplay deeplink modal video on opening
;
(function () {

    $(document)
        .on('modalOpened', function(e, modalTargetId) {
            var $modal = $('#' + modalTargetId);
            var $video = $('.js-m-modal-content-deeplinks-video', $modal);
            if (!$video.length) return false;

            if (!$video.is('video')) {
                $video.replaceWith('<video poster="'+ $video.data('poster') +'" class="u-ratio-item js-m-modal-content-deeplinks-video" muted loop playsinline><source src="'+ $video.data('src') +'" type="video/mp4"></video>');

                $video = $('.js-m-modal-content-deeplinks-video', $modal);
            }

            // Attach an event listener to trigger the video.
            $video.on('canplaythrough', function() {
                this.play();
            });

            // Check the readystate of the video as sometimes it fires the
            // canplaythrough event before we've attached our listener.
            for (var i = 0; i < $video.length; i++) {
                if ($video[i].readyState > 3) {
                    $video[i].play();
                }
            }
        })
        .on('modalClosed', function(e, modalTargetId) {
            var $video = $('.js-m-modal-content-deeplinks-video');
            if (!$video.length || !$video.is('video')) return false;

            $video.each(function () {
                if ($(this).is('video')) {
                    $(this).get(0).pause();
                }
            })
        })

})();